import { dataLetterSpacing } from 'dls-icons-data'
import { createIcon } from '../common'

const IconLetterSpacing = /*#__PURE__*/createIcon(dataLetterSpacing)
export default IconLetterSpacing
